import { render } from "./AddOnCard.vue?vue&type=template&id=fa37c66e&scoped=true"
import script from "./AddOnCard.vue?vue&type=script&lang=js"
export * from "./AddOnCard.vue?vue&type=script&lang=js"

import "./AddOnCard.vue?vue&type=style&index=0&id=fa37c66e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa37c66e"]])

export default __exports__